import React, { Fragment, Component } from 'react'
import {
    Container,
    Row, Col,
    CardBody, Card, CardTitle, CardSubtitle,
    Button,
    Fieldset, Legend, Label
} from "reactstrap"
import { accessRole } from '../../../../helpers/access_role'

import { ConfirmAlert } from '../../../../helpers/ui/alert'
import { FileInput, generateFormData, Preview } from '../../../../helpers/ui/FileInput'
import CustomSelect from '../../../../helpers/ui/CustomSelect'
import { AvForm, AvGroup, AvInput, AvField, AvCheckboxGroup, AvCheckbox } from "availity-reactstrap-validation"

import { Link, useHistory, Redirect } from "react-router-dom"

import apiResponse from '../../../../services/apiResponse'
import { cancelToken } from '../../../../services/adapters/kepegawaian/seminarService'

import PegawaiSideBar from '../../GlobalComponents/PegawaiSidebar'
import UpdateBloc from './Blocs/UpdateBloc'
import IndexBloc from '../Index/Blocs/DataTableBloc'
import RegionBloc from '../Index/Blocs/IndexBloc'

class UpdateView extends Component {

    updateBloc = new UpdateBloc()
    indexBloc = new IndexBloc()
    regionBloc = new RegionBloc()

    // Retrieve Data Pegawai by Admin / Pegawai
    userdata = JSON.parse(localStorage.getItem('userdata'));
    employeeSeleted = JSON.parse(localStorage.getItem('employeeSelected'));
    peg_uuid = !accessRole('approve') ? (this.userdata != null ? this.userdata.employee_uuid : "") 
    : (this.employeeSeleted != null ? this.employeeSeleted.employee_uuid : "")
    peg_nip = !accessRole('approve') ? (this.userdata != null ? this.userdata.employee_nip : "") 
    : (this.employeeSeleted != null ? this.employeeSeleted.employee_nip : "")

    source
    constructor(props) {
        super(props)
        this.state = {
            detail: [],
            dataForm: {},
            domicile: 0,
            typeOption: [
                {
                    label : "Kursus",
                    value : 1
                },
                {
                    label : "Seminar",
                    value : 2
                },
                {
                    label : "Workshop",
                    value : 3
                },
            ],
            regionOption: [],
            provinceOption: [],
            cityOption: [],
            typeName: '-',
        }
    }

    getCity = (province_uuid) => {
        const query = { 
            is_local: 1,
            type : 3,
            parent_uuid : province_uuid
        }
        this.regionBloc.fetchRegionCity(query, this.source.token)
    }

    loadProvince = async () => {
        const query = { 
            parent_uuid: '61b47307-167d-489f-bb6c-c1c9662acab3',
            type: 2
        }
        await this.regionBloc.fetchRegionProvince(query, this.source.token)
    }

    loadRegion = async () => {
        const query = { type: 1 }
        await this.regionBloc.fetchRegion(query, this.source.token)
    }

    loadDetail = async () => {
        const query = {
            uuid: this.props.id
        }
        await this.indexBloc.fetchDetail(query, this.source.token)
    }

    setTokenAPI = () => {
        if (typeof this.source != typeof undefined) {
            this.source.cancel();
        }
        this.source = cancelToken()
        this.loadDetail()
        this.loadRegion()
        this.loadProvince()
    }

    submitData = async () => {
        const formData = generateFormData(this.state.dataForm, 'document') // 'document' disini adalah nama field FileInput. Jika ada lebih dari 1 file input, maka gunakan array. conth: ['document', 'foto'] 
        await this.updateBloc.fetchUpdate(formData)
    }

    handlerOnSubmit = (e, values) => {
        e.preventDefault()
        this.setState({
            dataForm: {
                uuid: this.props.id,
                employee_uuid : this.peg_uuid,
                ...values
            },
            confirm: true
        })
    }

    confirmResponse = (response) => {
        let forState = {}
        switch(response) {
            case 'cancel':
                forState = {
                    confirm: false
                }
                break;
            case 'confirm':
                forState = {
                    loading: true,
                    confirm: false
                }
                this.submitData()
                break;
            case 'success':
                forState = {
                    success: false,
                    redirect: true
                }
                break;
             case 'failed':
                forState = {
                    failed: false
                }
                break;
            default:       
        }
        this.setState(forState)
    }


    componentDidMount() {
        this.setTokenAPI()

        this.regionBloc.regionCityChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ cityOption: result.data.response.result })
                    break;
                default:
                    break;
            }
        })

        this.regionBloc.regionProvinceChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ provinceOption: result.data.response.result })
                    break;
                default:
                    break;
            }
        })

        this.regionBloc.regionChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ regionOption: result.data.response.result })
                    break;
                default:
                    break;
            }
        })

        this.indexBloc.detailChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({ detail: result.data.response, domicile: result.data.response.seminar_domicile, typeName: result.data.response.seminar_type_name })
                    this.getCity(result.data.response.seminar_province_uuid)
                    break;
                case apiResponse.ERROR:
                    break;
                default:
                    break;
            }
        })

        this.updateBloc.updateChannel.subscribe((result) => {
            switch (result.status) {
                case apiResponse.COMPLETED:
                    this.setState({
                        loading: false,
                        success: true,
                    });
                    break
                case apiResponse.ERROR:
                    this.setState({
                        loading: false,
                        failed: true,
                    });
                    break
                default:
                    break
            }
        })

    }

    componentWillUnmount() {
        this.updateBloc.updateChannel?.unsubscribe()
        this.indexBloc.detailChannel?.unsubscribe()
    }


    render() {
        const { detail } = this.state
        console.log('cek', detail)
        return (
            <Fragment>
                <Container fluid>
                    <Row>
                        <Col className="col-12">

                            <PegawaiSideBar active="seminar"/>

                            <Card className="pegawai-rightbar">
                                <CardBody>
                                    <div className="float-end">
                                        <Link to={`?seminar`}>
                                            <Button outline color="primary"><i className="uil uil-backward"></i> Kembali</Button>
                                        </Link>
                                    </div>
                                    <CardTitle>Edit Kursus \ Seminar \ Workshop</CardTitle>
                                    <CardSubtitle className="mb-3">
                                        Setiap isian yang bertanda (<span className="text-danger">*</span>) adalah wajib diisi.
                                    </CardSubtitle>
                                    <hr />
                                    <AvForm
                                        className="needs-validation"
                                        onValidSubmit={(e, values) => this.handlerOnSubmit(e, values)}
                                    >
                                        <Row className="mb-3">
                                            <Label className="col-md-2 col-form-label">Jenis<span className="text-danger">*</span></Label>
                                             <Col md="3">
                                                <CustomSelect 
                                                    name="seminar_type"
                                                    errorMessage="Pilih Jenis"
                                                    options={this.state.typeOption}
                                                    onChange={opt => this.setState({ typeName: opt.label })}
                                                    placeholder="Pilih Jenis"
                                                    defaultValue={detail?.seminar_type}
                                                    validate={{ required: { value: true } }}
                                                    isSearchable={false}
                                                />
                                            </Col>                                           
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                htmlFor="fieldNama"
                                                className="col-md-2 col-form-label"
                                            >
                                                Nama {this.state.typeName} <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="6">
                                                <AvField
                                                    name="seminar_name"
                                                    placeholder="Nama Seminar"
                                                    errorMessage="Masukkan Nama Seminar"
                                                    type="text"
                                                    className="form-control"
                                                    id="fieldNama"
                                                    value={detail?.seminar_name}
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>

                                        <hr/>
                                        <Label># Tempat {this.state.typeName}</Label>
                                        <Row className="mb-3">
                                            <Label className="col-md-2 col-form-label">Dalam / Luar Negeri<span className="text-danger">*</span></Label>
                                             <Col md="3">
                                                <CustomSelect 
                                                    name="seminar_domicile"
                                                    errorMessage="Pilih Domisili"
                                                    options={[{ value: 0, label: 'Dalam Negeri' }, { value: 1, label: 'Luar Negeri' }]}
                                                    onChange={opt => this.setState({ domicile: opt.value })}
                                                    placeholder="Pilih Domisili"
                                                    validate={{ required: { value: true } }}
                                                    defaultValue={this.state.domicile}
                                                    isSearchable={false}
                                                />
                                            </Col>                                           
                                        </Row>
                                        { this.state.domicile == 0 ?
                                            <Fragment>
                                                <AvField 
                                                    type="hidden" 
                                                    name="seminar_country_uuid" 
                                                    value={this.state.regionOption?.filter(value => value.region_name == 'Indonesia')[0]?.region_uuid} 
                                                />
                                                <Row className="mb-3">
                                                    <Label
                                                        className="col-md-2 col-form-label"
                                                    >
                                                    Provinsi <span className="text-danger">*</span>
                                                    </Label>
                                                    <Col md="3">
                                                        <CustomSelect 
                                                            name="seminar_province_uuid"
                                                            errorMessage="Pilih Provinsi"
                                                            onChange={value => this.getCity(value.region_uuid)}
                                                            options={this.state.provinceOption}
                                                            optionLabel="region_name"
                                                            optionValue="region_uuid" 
                                                            validate={{ required: { value: true } }}
                                                            defaultValue={detail?.seminar_province_uuid}
                                                            placeholder="Pilih Provinsi"
                                                        />
                                                    </Col>
                                                </Row>
                                                <Row className="mb-3">
                                                    <Label
                                                        className="col-md-2 col-form-label"
                                                    >
                                                        Kota <span className="text-danger">*</span>
                                                    </Label>
                                                    <Col md="3">
                                                        <CustomSelect 
                                                            name="seminar_city_uuid"
                                                            errorMessage="Pilih Kota"
                                                            options={this.state.cityOption} 
                                                            optionLabel="region_name"
                                                            defaultValue={detail?.seminar_city_uuid}
                                                            optionValue="region_uuid"
                                                            validate={{ required: { value: true } }}
                                                            placeholder="Pilih Kota"
                                                        />
                                                    </Col>
                                                </Row>
                                            </Fragment>
                                            :
                                            <Fragment>
                                                <Row className="mb-3">
                                                    <Label className="col-md-2 col-form-label">Negara <span className="text-danger">*</span></Label>
                                                    <Col md="3">
                                                        <CustomSelect 
                                                            name="seminar_country_uuid"
                                                            errorMessage="Pilih Negara"
                                                            options={this.state.regionOption}
                                                            optionValue="region_uuid"
                                                            optionLabel="region_name"
                                                            defaultValue={detail?.seminar_country_uuid}
                                                            placeholder="Pilih Negara"
                                                            validate={{ required: { value: true } }}
                                                        />
                                                    </Col>                                           
                                                </Row>
                                                <Row className="mb-3">
                                                    <Label
                                                        className="col-md-2 col-form-label"
                                                    >
                                                    Kota <span className="text-danger">*</span>
                                                    </Label>
                                                    <Col md="3">
                                                        <AvField
                                                            name="seminar_city_text"
                                                            placeholder="Kota..."
                                                            type="text"
                                                            errorMessage="Masukkan Kota"
                                                            className="form-control"
                                                            validate={{ required: { value: true } }}
                                                            id="place_of_birth_city_text"
                                                            defaultValue={detail?.seminar_city_text}
                                                        />
                                                    </Col>
                                                </Row>
                                            </Fragment> 
                                        }
                                        <hr/>
                                        <Row className="mb-3">
                                            <Label
                                                htmlFor="fieldPenyelenggara"
                                                className="col-md-2 col-form-label"
                                            >
                                                Penyelanggara <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="6">
                                                <AvField
                                                    name="seminar_organizer"
                                                    placeholder="Nama Penyelanggara"
                                                    errorMessage="Masukkan Penyelanggara"
                                                    type="text"
                                                    className="form-control"
                                                    id="fieldPenyelenggara"
                                                    value={detail?.seminar_organizer}
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>


                                        <Row className="mb-3">
                                            <Label
                                                htmlFor="fieldTglMulai"
                                                className="col-md-2 col-form-label"
                                            >
                                                Tanggal Mulai <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="3">
                                                <AvField
                                                    name="seminar_start_date"
                                                    placeholder="Tanggal Mulai"
                                                    errorMessage="Masukkan Tanggal Mulai"
                                                    type="date"
                                                    className="form-control"
                                                    id="fieldTglMulai"
                                                    value={detail?.seminar_start_date}
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                htmlFor="fieldTglSelesai"
                                                className="col-md-2 col-form-label"
                                            >
                                                Tanggal Selesai <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="3">
                                                <AvField
                                                    name="seminar_end_date"
                                                    value={detail?.seminar_end_date}
                                                    placeholder="Tanggal Selesai"
                                                    errorMessage="Masukkan Tanggal Selesai"
                                                    type="date"
                                                    className="form-control"
                                                    id="fieldTglSelesai"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                htmlFor="fieldNoPiagam"
                                                className="col-md-2 col-form-label"
                                            >
                                                No Piagam <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="4">
                                                <AvField
                                                    name="seminar_charter_number"
                                                    value={detail?.seminar_charter_number}
                                                    placeholder="No Piagam"
                                                    errorMessage="Masukkan No Piagam"
                                                    type="text"
                                                    className="form-control"
                                                    id="fieldNoPiagam"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                htmlFor="fieldTglPiagam"
                                                className="col-md-2 col-form-label"
                                            >
                                                Tanggal Piagam <span className="text-danger">*</span>
                                            </Label>
                                            <Col md="3">
                                                <AvField
                                                    name="seminar_charter_date"
                                                    value={detail?.seminar_charter_date}
                                                    placeholder="Tanggal Piagam"
                                                    errorMessage="Masukkan Tanggal Piagam"
                                                    type="date"
                                                    className="form-control"
                                                    id="fieldTglPiagam"
                                                    validate={{ required: { value: true } }}
                                                />
                                            </Col>
                                        </Row>

                                        <Row className="mb-3">
                                            <Label
                                                htmlFor="fieldTglPiagam"
                                                className="col-md-2 col-form-label"
                                            >
                                                File Piagam
                                            </Label>
                                            <Col md="6">
                                                <FileInput 
                                                    name="document"
                                                    // defaultValue={detail?.document}
                                                />
                                                <br />
                                                <Preview
                                                    value={detail?.document}
                                                />
                                            </Col>
                                        </Row>

                                       <Row className="mb-3">
                                            <Col md="3"></Col>
                                            <Col md="9">
                                                <Link to="/kepegawaian/home.html?seminar">
                                                    <Button color="danger" type="button"><i className="uil-arrow-left"></i> Kembali</Button>
                                                </Link>
                                                {' '}
                                                <Button color="success" type="submit">
                                                    <i className="uil-arrow-up-right"></i> Simpan Data
                                                </Button>
                                            </Col>
                                        </Row>

                                    </AvForm>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
                <ConfirmAlert
                    confirmTitle="Konfirmasi!"
                    confirmInfo="Apakah anda yakin akan menyimpan data ini?"

                    loadingTitle="Mengirim data..."
                    loadingInfo="Tunggu beberapa saat"

                    successTitle="Berhasil!"
                    successInfo="Data berhasil disimpan"

                    failedTitle="Gagal!"
                    failedInfo="Data gagal disimpan"

                    showConfirm={this.state.confirm}
                    showLoading={this.state.loading}
                    showSuccess={this.state.success}
                    showFailed={this.state.failed}

                    response={this.confirmResponse}
                />
                { this.state.redirect ?
                    <Redirect to='/kepegawaian/home.html?seminar'/>
                : null }               
            </Fragment>
        )
    }

}

export default UpdateView;
